import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { memo } from "react";
import logoVesteia from "@/assets/logo-vesteia-full.png";

export const Header = memo(function Header() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass border-b border-border">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img 
            src={logoVesteia} 
            alt="VesteIA" 
            className="h-[120px]" 
            loading="eager"
            decoding="async"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-6">
          <a href="#beneficios" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
            Benefícios
          </a>
          <a href="#como-funciona" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
            Como Funciona
          </a>
          <a href="#planos" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
            Planos
          </a>
          <a href="#faq" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
            FAQ
          </a>
        </nav>

        <div className="flex items-center gap-3">
          <Button variant="ghost" asChild>
            <Link to="/auth">Entrar</Link>
          </Button>
          <Button className="gradient-primary border-0" asChild>
            <Link to="/auth?tab=signup">Criar Conta</Link>
          </Button>
        </div>
      </div>
    </header>
  );
});
